import {
  AfterContentChecked,
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
} from '@angular/core';
import * as _ from 'lodash';
import { ScwMatInputComponent } from '../scw-mat-input/scw-mat-input.component';
import { ScwMatSelectComponent } from '../scw-mat-select/scw-mat-select.component';
import { ScwMatButtonComponent } from '../scw-mat-button/scw-mat-button.component';
import { ScwMatDatepickerComponent } from '../scw-mat-datepicker/scw-mat-datepicker.component';
import { ScwMatCronInputComponent } from '../scw-mat-cron-input/scw-mat-cron-input/scw-mat-cron-input.component';
import { ScwMatPickerComponent } from '../scw-mat-picker/scw-mat-picker.component';

@Component({
  selector: 'scw-mat-form',
  templateUrl: './scw-mat-form.component.html',
  styleUrls: ['./scw-mat-form.component.scss'],
})
export class ScwMatFormComponent implements AfterContentInit, AfterContentChecked {
  @Input() overrideButtons: QueryList<ScwMatButtonComponent>;
  @Input() overrideSelects: QueryList<ScwMatSelectComponent>;
  @Input() overrideInputs: QueryList<ScwMatInputComponent>;
  @Input() overrideDatePickers: QueryList<ScwMatDatepickerComponent>;
  @Input() overrideCronInputs: QueryList<ScwMatCronInputComponent>;
  @Input() overridePickers: QueryList<ScwMatPickerComponent>;

  @ContentChildren(ScwMatInputComponent, { descendants: true }) public _inputs: QueryList<ScwMatInputComponent>;
  @ContentChildren(ScwMatSelectComponent, { descendants: true }) public _selects: QueryList<ScwMatSelectComponent>;
  // tslint:disable-next-line:max-line-length
  @ContentChildren(ScwMatDatepickerComponent, { descendants: true })
  public _datePickers: QueryList<ScwMatDatepickerComponent>;
  @ContentChildren(ScwMatButtonComponent, { descendants: true }) public _buttons: QueryList<ScwMatButtonComponent>;
  @ContentChildren(ScwMatCronInputComponent, { descendants: true })
  public cronInputList: QueryList<ScwMatCronInputComponent>;
  @ContentChildren(ScwMatPickerComponent, { descendants: true }) public _pickers: QueryList<ScwMatPickerComponent>;
  @Output() submit: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isValid: boolean;
  public buttons: QueryList<ScwMatButtonComponent>;
  public inputs: QueryList<ScwMatInputComponent>;
  public selects: QueryList<ScwMatSelectComponent>;
  public datePickers: QueryList<ScwMatDatepickerComponent>;
  public cronInputs: QueryList<ScwMatCronInputComponent>;
  public pickers: QueryList<ScwMatPickerComponent>;

  private isInputsAreValid(): boolean {
    return _.find(_.get(this.inputs, '_results'), { isValid: false }) === undefined;
  }

  private isSelectsAreValid(): boolean {
    return _.find(_.get(this.selects, '_results'), { isValid: false }) === undefined;
  }

  private isDatePickersAreValid(): boolean {
    return _.find(_.get(this.datePickers, '_results'), { isValid: false }) === undefined;
  }

  private areCronInputsValid(): boolean {
    return _.find(_.get(this.cronInputs, '_results'), { isValid: false }) === undefined;
  }

  private isValidChecker(): void {
    this.isValid =
      this.isInputsAreValid() && this.isSelectsAreValid() && this.isDatePickersAreValid() && this.areCronInputsValid();
  }

  public reset(): void {
    for (const input of _.get(this.inputs, '_results')) {
      input.reset();
    }

    for (const select of _.get(this.selects, '_results')) {
      select.reset();
    }

    for (const datepicker of _.get(this.datePickers, '_results')) {
      datepicker.reset();
    }

    for (const cronInput of _.get(this.cronInputs, '_results')) {
      cronInput.reset();
    }
  }

  public triggerRuleCheckers(): boolean {
    for (const input of _.get(this.inputs, '_results')) {
      input.checkRules();
    }

    for (const select of _.get(this.selects, '_results')) {
      select.checkRules();
    }

    for (const datepicker of _.get(this.datePickers, '_results')) {
      datepicker.checkRules();
    }

    for (const cronInput of _.get(this.cronInputs, '_results')) {
      cronInput.checkRules();
    }

    for (const picker of _.get(this.pickers, '_results')) {
      picker.checkRules();
    }

    this.isValidChecker();

    return this.isValid;
  }

  public ngAfterContentChecked(): void {
    this.isValidChecker();
  }

  public ngAfterContentInit(): void {
    this.buttons = this.overrideButtons ?? this._buttons;
    this.inputs = this.overrideInputs ?? this._inputs;
    this.selects = this.overrideSelects ?? this._selects;
    this.datePickers = this.overrideDatePickers ?? this._datePickers;
    this.cronInputs = this.overrideCronInputs ?? this.cronInputList;
    this.pickers = this.overridePickers ?? this._pickers;

    this.buttons.forEach((item) => {
      if (item.submit !== false) {
        item.onClickEmitterForScwMatForm = () => {
          this.triggerRuleCheckers();
          this.submit.emit(this.isValid);
        };
      }
    });
  }
}
